import React, { useEffect } from 'react';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { useBWTag } from '@whitelabel/helpers/hooks';
import { routes } from '../../routes/routes';
import ErrorPage from '../../components/ErrorPage';
import ProtectedLayout from '../layout/ProtectedLayout';
import { store } from '../../store';
import SharedRouterProvider from '../../components/SharedRouterProvider';

document.body.className += ' rentalcover-theme';

const App = () => {
  const { pathname } = useLocation();
  const { path: basePath } = useRouteMatch();

  useEffect(() => {
    setupListeners(store.dispatch);
  }, []);

  useBWTag();

  return (
    <Switch>
      <Redirect
        from="/(.+)/"
        strict
        exact
        to={{ pathname: pathname.slice(0, -1), search: window.location.search, hash: window.location.hash }}
      />
      {routes.map(({ component: Component, path, isPublic, ...rest }) => (
        <Route {...rest} path={`${basePath}${path}`}>
          <SharedRouterProvider>
            {isPublic ? (
              <Component />
            ) : (
              <ProtectedLayout>
                <Component />
              </ProtectedLayout>
            )}
          </SharedRouterProvider>
        </Route>
      ))}
      <Route render={(routerProps) => <ErrorPage {...routerProps} isNoMatch />} />
    </Switch>
  );
};

export default App;
